import { ClienteDto, DatiAnagraficiCedacriDto, ErrorResponseDto } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { RicercaAnagrafeReducerType } from "./types";

const ricercaAnagrafeReducer = (state: RootState): RicercaAnagrafeReducerType => state.ricercaAnagrafe;

export const ndgSelector = createSelector(
  ricercaAnagrafeReducer,
  (state: RicercaAnagrafeReducerType): string => {
    return state.ndg;
  }
);

export const clienteSelezionatoSelector = createSelector(
  ricercaAnagrafeReducer,
  (state: RicercaAnagrafeReducerType): ClienteDto | undefined => {
    return state.clienteSelezionato;
  }
);

export const erroreAddAnagraficaCedacri = createSelector(
  ricercaAnagrafeReducer,
  (state: RicercaAnagrafeReducerType): ErrorResponseDto | undefined => {
    return state.erroreAddAnagraficaCedacri;
  }
);

export const clienteRicercatoSelector = createSelector(
  ricercaAnagrafeReducer,
  (state: RicercaAnagrafeReducerType): DatiAnagraficiCedacriDto | undefined => {
    return state.clienteRicercato;
  }
);
